<template>
  <div class="">
    <m-update-site-message1/>
    <router-view name="site"/>
  </div>
</template>

<script>
import {defineComponent} from 'vue'

export default defineComponent({
  name: "SiteLayout",
})
</script>

<style scoped>

</style>